import _ from 'lodash'

export default (rows) => _.map(_.map(rows, 'value'), _.toNumber)
